import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { questionSettings } from '../../core/interfaces/questionSettings';
import QRCode from 'qrcode';
import { BitWiseParser } from '../../../assets/helper/bitwiseParser';

@Injectable({
  providedIn: 'root',
})
export class DataShareServiceService {
  public allowedQuestionTypeService: BehaviorSubject<string[]> =
    new BehaviorSubject<string[]>([]);

  public allowedTreeTypeService: BehaviorSubject<string[]> =
    new BehaviorSubject<string[]>([]);

  public allowedSubjectService: BehaviorSubject<string[]> = new BehaviorSubject<
    string[]
  >([]);

  private questionSettingsSubject: BehaviorSubject<questionSettings[]> =
    new BehaviorSubject<questionSettings[]>([]);

  public projectService: BehaviorSubject<any> = new BehaviorSubject<any>(null);

  public projectIdService: BehaviorSubject<string> =
    new BehaviorSubject<string>('');

  public userData: BehaviorSubject<any | null> = new BehaviorSubject<
    any | null
  >(null);

  private selectedQuestionType = new BehaviorSubject<string>('');
  selectedQuestionType$ = this.selectedQuestionType.asObservable();

  private filteredDataSubject = new BehaviorSubject<any[]>([]);
  filteredData$ = this.filteredDataSubject.asObservable();

  // private projectConfigEnabledSubject = new BehaviorSubject<boolean>(false);
  // projectConfigEnabled$ = this.projectConfigEnabledSubject.asObservable();

  setFilteredData(data: any[]) {
    this.filteredDataSubject.next(data);
  }

  private allowedTreesSubject = new BehaviorSubject<any[]>([]);

  public questionDetails = new BehaviorSubject<any>(null);

  public qrData: string = '';

  constructor() {
    const storedProjectId = localStorage.getItem('projectId');
    if (storedProjectId) {
      this.projectIdService.next(storedProjectId);
      // Duplicate / refreshed tabs may lack sessionStorage while localStorage still
      // has the active project — keep both in sync so menu options stay visible.
      if (!sessionStorage.getItem('projectId')) {
        sessionStorage.setItem('projectId', storedProjectId);
      }
    }
  }

  public getAllowedQtypes$() {
    return this.allowedQuestionTypeService.asObservable();
  }

  public updateAllowedQtypesArray(newArray: string[]) {
    this.allowedQuestionTypeService.next(newArray);
  }

  public updateSkillTree$(newArray: any[]) {
    return this.allowedTreesSubject.next(newArray);
  }

  public getAllowedTrees$() {
    return this.allowedTreesSubject.asObservable();
  }

  public updateSubjectClass(newArray: any[]) {
    return this.allowedSubjectService.next(newArray);
  }

  public getAllowedSubject$() {
    return this.allowedSubjectService.asObservable();
  }

  public getQuestionSettings$() {
    return this.questionSettingsSubject.asObservable();
  }

  public updateQuestionSettings(newArray: questionSettings[]) {
    return this.questionSettingsSubject.next(newArray);
  }

  public setProject$(data: any) {
    this.projectService.next(data);
  }

  public getProject$() {
    return this.projectService.asObservable();
  }

  public setUserData(data: any) {
    localStorage.setItem('userData', JSON.stringify(data));
    return this.userData.next(data);
  }

  public getUserData() {
    const currentUserData = this.userData.getValue();
    if (currentUserData) {
      return currentUserData;
    }
    //fallback to local storage if no user data is found in behavior subject
    const storedUserData = localStorage.getItem('userData');

    if (storedUserData) {
      const userData = JSON.parse(storedUserData);
      return userData;
    } else {
      return null;
    }
  }

  public clearUserData() {
    return this.userData.next(null);
  }

  public setSelectedQuestionType(type: string) {
    this.selectedQuestionType.next(type);
  }

  public setProjectId(project_id: string): void {
    this.projectIdService.next(project_id);
    localStorage.setItem('projectId', project_id);
    sessionStorage.setItem('projectId', project_id);
  }

  public getProjectId$() {
    return this.projectIdService.asObservable();
  }

  setAllowedTrees(trees: any[]) {
    this.allowedTreesSubject.next(trees);
  }

  public setQuestionDetails(data: any) {
    this.questionDetails.next(data);
  }

  public getQuestionDetails() {
    return this.questionDetails.asObservable();
  }

  public setQuestionFilters(data: any) {
    sessionStorage.setItem('QuestionFilter', JSON.stringify(data));
  }
  public clearQuestionFilters() {
    sessionStorage.removeItem('QuestionFilter');
  }

  public setQuestionPageDetails(data: any) {
    sessionStorage.setItem('QuestionPageInfo', JSON.stringify(data));
  }

  public clearQuestionPageDetails() {
    sessionStorage.removeItem('QuestionPageInfo');
  }

  public setQuestionFieldDetails(data: any) {
    sessionStorage.setItem('QuestionFields', JSON.stringify(data));
  }

  public setPassageFilters(data: any) {
    sessionStorage.setItem('PassageFilter', JSON.stringify(data));
  }

  public setPassagePageDetails(data: any) {
    sessionStorage.setItem('PassagePageInfo', JSON.stringify(data));
  }

  public setPassageFieldDetails(data: any) {
    sessionStorage.setItem('PassageFields', JSON.stringify(data));
  }

  public getQuestionFilters() {
    return sessionStorage.getItem('QuestionFilter');
  }

  public getBulkReviewQuestionFilters() {
    return sessionStorage.getItem('BulkReviewQuestionFilter');
  }

  public clearBulkReviewQuestionFilters() {
    return sessionStorage.removeItem('BulkReviewQuestionFilter');
  }

  public setBulkReviewQuestionFilters(data: any) {
    sessionStorage.setItem('BulkReviewQuestionFilter', JSON.stringify(data));
  }









  public setBulkReviewSkillFilters(
    skillLevelLabels: any,
    selectedTopic: any,
    filteredTopicList: any,
    latestSkill: any
  ) {
    // this.dataService.setBulkReviewSkillFilters(this.skillLevelLabels, this.selectedTopic, this.filteredTopicList, this.latestSkill);

    sessionStorage.setItem(
      'BulkReviewSkillFilter',
      JSON.stringify({
        skillLevelLabels,
        selectedTopic,
        filteredTopicList,
        latestSkill,
      })
    )}
   
   public clearBulkReviewSkillFilters() {
    // this.dataService.setBulkReviewSkillFilters(this.skillLevelLabels, this.selectedTopic, this.filteredTopicList, this.latestSkill);
    return sessionStorage.removeItem('BulkReviewSkillFilter') 
  }

  public getBulkReviewSkillFilters() {
    // this.dataService.setBulkReviewSkillFilters(this.skillLevelLabels, this.selectedTopic, this.filteredTopicList, this.latestSkill);
    return JSON.parse(sessionStorage.getItem('BulkReviewSkillFilter') || '{}');
  }




public setQuestionListingSkillFilters(skillLevelLabels: any, selectedTopic: any, filteredTopicList: any, latestSkill: any) {
    // this.dataService.setQuestionListingSkillFilters(this.skillLevelLabels, this.selectedTopic, this.filteredTopicList, this.latestSkill);

    sessionStorage.setItem('QuestionListingSkillFilter', JSON.stringify({
      skillLevelLabels,
      selectedTopic,
      filteredTopicList,
      latestSkill
    }));
  }

  public clearQuestionListingSkillFilters() {
    sessionStorage.removeItem('QuestionListingSkillFilter');
  }

  public getQuestionListingSkillFilters() {
    // this.dataService.setQuestionListingSkillFilters(this.skillLevelLabels, this.selectedTopic, this.filteredTopicList, this.latestSkill);
    return JSON.parse(sessionStorage.getItem('QuestionListingSkillFilter') || '{}');
  }


  public setBulkReviewAllQuestionToggle(data: any) {
    sessionStorage.setItem('BulkReviewAllQuestionToggle', JSON.stringify(data));
  }

  public getBulkReviewAllQuestionToggle() {
    return sessionStorage.getItem('BulkReviewAllQuestionToggle');
  }

  public clearBulkReviewAllQuestionToggle() {
    return sessionStorage.removeItem('BulkReviewAllQuestionToggle');
  }

  public setBulkReviewTranslationContentToggle(data: boolean) {
    sessionStorage.setItem(
      'BulkReviewTranslationContentToggle',
      JSON.stringify(data)
    );
  }

  public getBulkReviewTranslationContentToggle() {
    return sessionStorage.getItem('BulkReviewTranslationContentToggle');
  }

  public clearBulkReviewTranslationContentToggle() {
    return sessionStorage.removeItem('BulkReviewTranslationContentToggle');
  }

  public getPassageFilters() {
    return sessionStorage.getItem('PassageFilter');
  }

  public getPassagePageDetails() {
    return sessionStorage.getItem('PassagePageInfo');
  }

  public getPassageFieldsDetails() {
    return sessionStorage.getItem('PassageFields');
  }

  public getQuestionPageDetails() {
    return sessionStorage.getItem('QuestionPageInfo');
  }

  public getQuestionFieldsDetails() {
    return sessionStorage.getItem('QuestionFields');
  }

  public clearQuestionSearchCache() {
    sessionStorage.removeItem('cacheSource');
    sessionStorage.removeItem('QuestionFilter');
    sessionStorage.removeItem('QuestionPageInfo');
    sessionStorage.removeItem('QuestionFields');
  }

  public clearPassageSearchCache() {
    sessionStorage.removeItem('passageCacheSource');
    sessionStorage.removeItem('PassageFilter');
    sessionStorage.removeItem('PassagePageInfo');
    sessionStorage.removeItem('PassageFields');
  }

  public setCacheSource(data: string) {
    sessionStorage.setItem('cacheSource', data);
  }

  public getCacheSource() {
    return sessionStorage.getItem('cacheSource');
  }

  public getPassageCacheSource() {
    return sessionStorage.getItem('passageCacheSource');
  }

  public getStimulusCacheSource() {
    return sessionStorage.getItem('stimulusCacheSource');
  }

  public setPassageCacheSource(data: string) {
    sessionStorage.setItem('passageCacheSource', data);
  }

  public setStimulusCacheSource(data: string) {
    sessionStorage.setItem('stimulusCacheSource', data);
  }

  public async generateQR(
    data: string | QRCode.QRCodeSegment[],
    size: number
  ): Promise<string> {
    try {
      const url = await QRCode.toDataURL(data, {
        scale: size / 100,
        errorCorrectionLevel: 'M',
      });
      this.qrData = url;
      return url;
    } catch (err) {
      console.error('Error generating QR code:', err);
      return '';
    }
  }

  public setContainerFilters(data: any) {
    sessionStorage.setItem('ContainerFilter', JSON.stringify(data));
  }

  public setContainerPageDetails(data: any) {
    sessionStorage.setItem('ContainerPageInfo', JSON.stringify(data));
  }

  public setContainerFieldDetails(data: any) {
    sessionStorage.setItem('ContainerFields', JSON.stringify(data));
  }

  public getContainerFilters() {
    return sessionStorage.getItem('ContainerFilter');
  }

  public getContainerPageDetails() {
    return sessionStorage.getItem('ContainerPageInfo');
  }

  public getContainerFieldsDetails() {
    return sessionStorage.getItem('ContainerFields');
  }

  public clearContainerSearchCache() {
    sessionStorage.removeItem('ContainerFilter');
    sessionStorage.removeItem('ContainerPageInfo');
    sessionStorage.removeItem('ContainerFields');
  }

  public setMediaFilters(data: any) {
    sessionStorage.setItem('MediaFilter', JSON.stringify(data));
  }

  public setMediaPageDetails(data: any) {
    sessionStorage.setItem('MediaPageInfo', JSON.stringify(data));
  }

  public setMediaFieldDetails(data: any) {
    sessionStorage.setItem('MediaFields', JSON.stringify(data));
  }

  public getMediaFilters() {
    return sessionStorage.getItem('MediaFilter');
  }

  public getMediaPageDetails() {
    return sessionStorage.getItem('MediaPageInfo');
  }

  public getMediaFieldsDetails() {
    return sessionStorage.getItem('MediaFields');
  }

  public clearMediaSearchCache() {
    sessionStorage.removeItem("MediaFilter")
    sessionStorage.removeItem("MediaPageInfo")
    sessionStorage.removeItem("MediaFields")
  }

  /**
   * Set skill balance expanded state in session storage
   */
  public setSkillBalanceState(key: string, state: boolean): void {
    sessionStorage.setItem(key, JSON.stringify(state));
  }

  /**
   * Get skill balance expanded state from session storage
   */
  public getSkillBalanceState(key: string): boolean | null {
    const stored = sessionStorage.getItem(key);
    return stored ? JSON.parse(stored) : null;
  }

  /**
   * Set skill balance internal sections expanded state in session storage
   */
  public setSkillBalanceSectionsState(key: string, sectionsState: any): void {
    sessionStorage.setItem(key, JSON.stringify(sectionsState));
  }

  /**
   * Get skill balance internal sections expanded state from session storage
   */
  public getSkillBalanceSectionsState(key: string): any | null {
    const stored = sessionStorage.getItem(key);
    return stored ? JSON.parse(stored) : null;
  }

  public setAssembledContentState(type: 'question' | 'container', id: string, state: boolean): void {
  const allStates = this.getAllAssembledContentStates();
  const key = `${type}_${id}`;
  allStates[key] = state;
  sessionStorage.setItem('assembledContentStates', JSON.stringify(allStates));
}

public getAssembledContentState(type: 'question' | 'container', id: string): boolean | null {
  const allStates = this.getAllAssembledContentStates();
  const key = `${type}_${id}`;
  return allStates.hasOwnProperty(key) ? allStates[key] : null;
}

private getAllAssembledContentStates(): { [key: string]: boolean } {
  const stored = sessionStorage.getItem('assembledContentStates');
  return stored ? JSON.parse(stored) : {};
}

}
